// This JavaScript file is created by Cision and holds settings for all our modules.
// This file works as a config file for all the modules and here you will find genrall settings and a specific sektion for each module with its access key.

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.settings = cision.websolution.settings || {};

var baseUrl = '/';
var defaultLang = 'en';
var lang;

if ($('html').attr('lang') == 'sv' || $('html').attr('lang') == 'en' ) {    
    lang = $('html').attr('lang');
} else {
    lang = defaultLang;
}

cision.websolution.settings = {
    general: {
        // Settings that apply to all modules
        serviceEndpoint: 'https://publish.ne.cision.com/papi/',
        uiLanguage: lang,
        siteKey: 'se',
        // proxyHandler: '/project/templates/styleguide/ProxyCallsHttpHandler.php', // Change this to the one below if you can't run C#
        //proxyHandler: 'ProxyCallsHttpHandler.php',
        useProxyHandler: false,
        startDate: '',
        endDate: '',
        pageIndex: 1,
        pageSize: 10,
        dateFormat: 'D MMM YYYY',
        isTest: false,
        maxAmountOfItems: 10,
        useMediabankViaHttps: false, // for images in releases, set to true if you want to collect data via https
        numberFormatOptions: {
            thousandSeparator: ' ',
            decimalSeparator: '.',
            decimalPrecision: 2
        },
        dateFormatOptions: {
            dateTimeFormat: 'DD MMM YYYY HH:mm',
            dateFormat: 'DD MMM YYYY',
            timeFormat: 'HH:mm'
        },

        // Newsfeed specific settings
        dateFormatNews: "DD-MMM HH:mm",
        separateFirstRelease: false,
        introMaxLength: 155,
        titleMaxLength: null,

        // ownership specific settings
        LargestPieShowCount: 25,
        LargestListShowCount: 25,

        // Calendar specific settings
        dateFormatEvent: "YYYY-DD-MM, HH:mm",
        separateFirstEvent: false,

        // Printed Material specific settings
        printedMaterialCategory: '',

        // Ticker specific settings
        //tickerImageMinus: "http://feed.ne.cision.com/client/_images/papi/storminus.png",
        //tickerImagePlus: "http://feed.ne.cision.com/client/_images/papi/storplus.png",
        //tickerImageUnchanged: "http://feed.ne.cision.com/client/_images/papi/storunadjusted.png",
        tickerImageMinus: baseUrl + "delta-down.png",
        tickerImagePlus: baseUrl + "delta-up.png",
        tickerImageUnchanged: baseUrl + "delta-unchanged.png",
        dateFormatTrades: "DD-MMM",

        //Share calculator specific settings
        startDateYear: 2007,

        // Sharegraph specific settings
        chartContainerId: 'container',
        chartTitle: '',
        backgroundImage: '',
        barBackgroundColor: 'gray',
        lineWidth: '2',
        buttonBackgroundColor: 'gray',
        buttonArrowColor: 'white',
        rifleColor: 'white',
        plotBackgroundColor: 'white',
        defaultSeriesType: 'spline', /*Can be one of area, areaspline, bar, column, line, pie, scatter, spline, candlestick or ohlc. Since 1.1.7, types can also be arearange, areasplinerange and columnrange. */
        shapeColor: '#f27b7b',
        shapeOutlineColor: '#f27b7b',
        shapeTextColor: 'white',
        shapeWidth: 10,
        shapeHeight: 11,
        rangeSelectorInputStyleColor: '#f27b7b',
        rangeSelectorLabelStyleColor: '#f27b7b',
        trackBackgroundColor: 'white',
        trackBorderColor: 'silver',
        chartComparison: 'none', /* Default comparison type */
        typeOfChart: 'EndOfDay',
        navigatorColor: '#f27b7b',
        navigatorLineColor: '#f27b7b',
        showReleaseLink: true,
        gridLineWidth: '0',
        plotBorderWidth: '0',
        mainInstruments: [ /* As array of instruments to consider primary while others become Peers and Indexes */
            { symbol: 'SAND', marketPlace: 'XSTO', currency: 'SEKEFFECTIVEYIELD', name: 'Sandvik AB [Total Return]'}
            // { symbol: 'SAND', marketPlace: 'XSTO', currency: 'SEK', name: 'Sandvik AB' }
        ],
        indexInstruments: [
            { symbol: 'OMXSPI', marketPlace: 'XSTO', currency: 'SEK', name: 'OMX Stockholm PI' },
			{ symbol: 'OMXS30', marketPlace: 'XSTO', currency: 'SEK', name: 'OMX Stockholm 30 Index' },
			{ symbol: 'SX2000PI', marketPlace: 'XSTO', currency: 'SEK', name: 'OMX Stockholm Industrials PI' },
			{ symbol: 'OMXN40', marketPlace: 'XSTO', currency: 'EUR', name: 'OMX Nordic 40' }
        ],
        peersInstruments: [
            //{ symbol: 'TEL2 B', marketPlace: 'XSTO', currency: 'SEK', name: 'Tele 2' }
        ],
        releasesOnSeries: [
            { packageName: 'Regulatory RPT', symbol: 'SAND', marketPlace:  'XSTO', currency: 'SEK', shape: 'squarepin', title: 'R' },
            { packageName: 'Regulatory PRM', shape: 'squarepin', title: 'P' }
        ],
        instrumentColors: [
            // { uniqueKey: 'SANDXSTOSEK', preferredColor: '#f27b7b' },
            // { uniqueKey: 'OMXSPIXSTOSEK', preferredColor: '#4286f4' },
            // { uniqueKey: 'SANDXSTOSEKVOLUME', preferredColor: '#f38127' }
            { uniqueKey: 'SANDXSTOSEKEFFECTIVEYIELD', preferredColor: '#ff6a00' },
            { uniqueKey: 'SANDXSTOSEK', preferredColor: '#0099ff' },
			{ uniqueKey: 'OMXSPIXSTOSEK', preferredColor: '#d3d3d3' },
			{ uniqueKey: 'SANDXSTOSEKVOLUME', preferredColor: '#0099ff' }
        ],
        dividendType: 'Annual', /* Can be one of : Annual, Bonus, Monthly, Quarterly, HalfYear */
        effectiveYieldSuffix: 'EFFECTIVEYIELD',
        insidersUniqueKey: 'INSIDERS',
        dividendsUniqueKey: 'DIVIDEND',
        showVolume: true,
        enableNavigator: true,
        enableReleasesOnIntraday: true,
        yAxisSize: { share: { top: 0, height: 200 }, volume: { top: 300, height: 75 } },
        releaseLinkFormatter: 'https://publish.ne.cision.com/Release/ViewReleaseHtml/',
        insidersTitle: 'INS',
        graphUniqueKey: 'INSIDERS' /* Used when insiders placed on a shareGraph */,
        showHorisontalTicker: true,

        // Estimates specific settings
        estimateCurrency: '',
        graphColor: null,
        field: 'SALES' /* Sales-Volumes-ebit-DPS-EPS */,
        valuePrefix: '',
        valueSuffix: ' SEK',
        dateFormatTooltip: "Do MMMM YYYY",
        unit: "",
        quantum: "",
        tooltipHeaderEstimate: "Estimate - ",
        tooltipHeaderReal: "Actual - ",
        tooltipDateLabel: "",
        tooltipAmountLabel: "",
        suffixEstimate: ' FC',
        suffixActual: '',
        fields: {
            sales: { th_sep: ',', dec_sep: '.', precision: 0 },
            volumes: { th_sep: ',', dec_sep: '.', precision: 0 },
            ebit: { th_sep: ',', dec_sep: '.', precision: 0 },
            ebitda: { th_sep: ',', dec_sep: '.', precision: 0 },
            eps: { th_sep: ',', dec_sep: '.', precision: 2 },
            dps: { th_sep: ',', dec_sep: '.', precision: 2 }
        },
        periodStart: '',
        periodEnd: '',
        dateString: "",
        amountString: "",
        hideEstimateIfActualExists: true,

        //stores data if ownership tab is rendered
        ownershipTabLoaded: [],
        //stores data if estimate tab is rendered
        estimateTabLoaded: []
    },

    orderbook: {
        accessKey: 'CCBFBF90F13047028A7DA5F434E0DA1E'
    },

//    ownership: {
//        accessKey: '79B318BC2D6A4088BD690116403614CA'
//    },

    estimate: {
        accessKey: 'ADB9BA0873B04695B2D964FC95D89A12',
        accessKeyTicker: 'F2E063DEE79D46FA9114B158607A909B'
    },

    ticker: {
        accessKey: 'F2E063DEE79D46FA9114B158607A909B'
    },

    sharegraph: {
        accessKey: '403076B46AAE4AA3A23375D6F0DB394C',
        shareHistoryKey: '604503DCAD3A480889124A34280AED4D'
    },

    sharecalculator: {
        accessKey: 'CDB7A641484D42059453C084C5B634FF'
    },

    minisharegraph: {
        accessKey: '403076B46AAE4AA3A23375D6F0DB394C'
    },

//    newsfeed: {
//        accessKey: 'D004154BB1DA488FBA38A1C39D5DDBC4'
//    },

//    mediafeed: {
//        accessKey: '40073D268F8A4B69AF8CBC79CB901753'
//    },

    dividend: {
        accessKey: 'F2E063DEE79D46FA9114B158607A909B'
    },

    insider: {
        accessKey: '0C9AD8114C9E427D8709F3AD693D62EC'
    }

//    calendar: {
//        accessKey: 'AA6EFCAD94EA4F51AF041BC724F2328D'
//    },

//    printedMaterial: {
//        accessKey: '2D28E57C84A3444A802C85E94FB79FAA'
//    }

};

// Switch moment language
try {
    moment.locale(cision.websolution.settings.general.uiLanguage);
} catch (e) {

}

try {
    Highcharts.setOptions({
        lang: {
            decimalPoint: cision.websolution.settings.general.numberFormatOptions.decimalSeparator,
            thousandsSep: cision.websolution.settings.general.numberFormatOptions.thousandSeparator
        }
    });
} catch (e) {

}
